import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { AllowedReducer } from '@leverege/api-redux';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import RecovrSales from '../../util/RecovrSales';
import CreateTripacContractDialog from './CreateTripacContractDialog';
import C from '../../views/salesFlow/Constants';
const {
  t,
  tIcon
} = I18N.ns('recovr.actions.createTripacContract.CreateTripacContractAction');
export default {
  id: 'recovr.sale.createTripacContract',
  name: 'Create Tripac Contract',
  layout: {
    sort: 'sale.zCreateTripacContract'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  appearance: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const targets = context.targets || context.target;
    const count = targets.length;
    return {
      name: count > 1 ? t('pluralName', {
        count
      }) : t('name'),
      icon: tIcon('icon'),
      iconOpts: {
        style: {
          fontSize: '16px',
          marginRight: '8px'
        }
      }
    };
  },
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    const companyId = targets[0]?.data?.data?.company?.id;
    const locationId = targets[0]?.data?.data?.location?.id;
    const saleId = targets[0]?.id;
    if (targets == null || targets.length === 0) {
      return false;
    }
    return RecovrSales.canCreateTripacContract({
      companyId,
      locationId,
      saleId
    });
  },
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0) {
      return true;
    }
    const deviceId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), deviceId);
    return a.createTripacContract != null;
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0) {
      return false;
    }

    // check if all selected sales have a location with warranty enabled
    const isWarrantyEnabled = targets.every(sale => {
      const saleType = sale.data?.data?.type;
      const productTypeRecovr = sale.data?.data?.productTypes?.recovr;
      const productTypeKeys = sale.data?.data?.productTypes?.recovrKeys;
      const saleTypeHasWarranty = C.SALE_TYPES_WITH_WARRANTY.includes(saleType);
      const isNotVoid = sale.data?.data?.state !== C.SALE_STATUSES.VOID;
      // if at least one of the warranties is empty, allow create button
      const noCurrentWarranty = Number.isNaN(parseInt(sale.data?.data?.vehicle?.warrantyId)) && productTypeRecovr || Number.isNaN(parseInt(sale.data?.data?.keysWarranty?.warrantyId)) && productTypeKeys;
      return saleTypeHasWarranty && noCurrentWarranty && isNotVoid;
    });
    const a = AllowedReducer.get(GlobalState.get(), targets[0]?.id);
    return a.createTripacContract === true && isWarrantyEnabled;
  },
  perform: props => {
    const context = props?.context?.clientState?.actionsContext || props.context;
    const {
      clientProps
    } = context;
    const targets = Context.getTargetsOfType(context, 'sale');
    if (!targets[0]) {
      return;
    }
    Dialogs.show({
      id: 'createTripacContract',
      component: CreateTripacContractDialog,
      props: {
        targets,
        context,
        reloadData: context.reloadData || clientProps.reloadData
      }
    });
  }
};